module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
/** Grid Pager Widget */

(function(fox, $) {

	fox.registerWidget('Grid_Pager', {

		//Widget config
		configure: function(options) {
			this.registerOptions('', {
				ignoreActivate: false,
				notSetTotalCount: false,
				pagesCount: 10,
				handleDom: {
					setPage: {
						target: '.page',
						event: 'click',
						callback: function(el, alias, scope) {
							scope.changePage($(el).attr('data-page'));
						}
					}
				},
				'wrapMethods.changePage': true
			});

			this.callParent('configure', arguments);
		},

		init: function() {
			this._pagerData = {};
			this.dl = this.options.dataLayer;
			this.dl.initPagerMode(this.getOption('notSetTotalCount'));
			this.navPrefix = this.options.navigatorPrefix;

			if (this.navPrefix) {
				this.handleEvent(fox.Navigator, 'modified_' + this.navPrefix, '_loadPage', {
					listenHistory: true
				});
			}

			this.handleEvent(this.dl, 'loaded', fox.bind(function() {this._calculatePagerData();this.render();} , this));
		},

		_calculatePagerData: function() {
			var data = fox.clone(this.dl.getPagerData()), start, leftOffset, rightOffset, end;

			if (data.total < 2) {
				this.removeFromDom();
				this._indom = false;
				this._rendered = false;
				this._pagerData = data;
			} else {
				data.cp = Number(data.cp);
				data.first = 1;
				var cnt = this.options.pagesCount;

				leftOffset = Math.floor(cnt/2);
				rightOffset = leftOffset;

				if (cnt % 2) {
					leftOffset--;
				}

				//calculating pages block
				if (data.cp <= leftOffset) {
					start = 1;
					rightOffset = rightOffset + (leftOffset - data.cp);
				} else {
					start = data.cp - leftOffset;
				}

				if (data.total <= (data.cp + rightOffset)) {
					end = data.total;
				} else {
					end = data.cp + rightOffset;
					if(end > data.total) {
						end = data.total;
					}
				}

				//do you need to show spacers
				if (start > data.first && cnt < data.total ) {
					data.startSpacer = 1;
				} else {
					data.startSpacer = 0;
				}

				if (data.cp + 2 < data.total) {
					data.endSpacer = 1;
				} else {
					data.endSpacer = 0;
				}

				data.pages = [];

				for (var i = start, l = end; i <= l; i++) {
					data.pages.push({
						id: i,
						page: i,
						current: i === data.cp,
						first: i === data.first,
						last: i === data.total,
						firstInBlock: i === start,
						lastInBlock: i === end
					});
				}
				this._pagerData = data;
			}
		},

		changePage: function(page) {
			if (page == 'next') {
				page = this.dl.getNextPageNumber();
			}

			if (page == 'prev') {
				page = this.dl.getPrevPageNumber();
			}

			if (page === 0) {
				return;
			}

			if (this.navPrefix) {
				fox.Navigator.set(this.navPrefix, page, false);
			} else {
				this._loadPage(page);
			}
			return this;
		},

		_loadPage: function(page) {
			if (this._pagerData.cp != page) {
				this.dl.changePage(fox.isNumeric(page) ? page : 1);
			}
		},

		rendering: function() {
			if (fox.isSet(this._pagerData) && fox.isSet(this._pagerData.total) && (this._pagerData.total < 2)) {
				this.fragment = this.createFragment();
				return ;
			}

			if (!this.row) {
				this.row = this.getTemplater(this.getOption('tpl.container'));
			}

			this.fragment = this.row.setData(this._pagerData).compile();
		},

		activate: function() {
			this._calculatePagerData();
			if (!this.options.ignoreActivate && this._pagerData.cp != 1 && !this.navPrefix) {
				this._loadPage(1);
			}

			if (this.getOption('resetPageOnActivate') && (fox.Navigator.get(this.navPrefix) != this._pagerData.cp)) {
				this._loadPage(1);
			}

			this.callParent('activate', arguments);
		}
	});

})(fox, fox.jQuery);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-core-resource/lib/widgets/grid/pager.js
// module id = 202
// module chunks = 0